import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.payment_systempay';
export const Component = loadable(
  () => import('./containers/PaymentSystempayContainer')
);
export { default as propsFormatter } from './propsFormatter';
